// src/components/auth/VerifyNotice.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Mail, 
  ArrowLeft, 
  MessageCircle, 
  CheckCircle, 
  AlertCircle,
  ExternalLink 
} from 'lucide-react';

const VerifyNotice = () => {
  const location = useLocation();
  // Get the email passed from the Signup navigation state, or fallback
  const email = location.state?.email || "your registered email address";

  return (
    <div className="bg-[#f6ecf6] min-h-screen flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden animate-in fade-in zoom-in duration-500">
        
        {/* Top Gradient Bar */}
        <div className="h-2 w-full" style={{ background: 'linear-gradient(to right, #250242, #8a1e78ff)' }}></div>
        
        <div className="p-8 text-center">
          {/* Animated Mail Icon */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-purple-100 rounded-full animate-ping opacity-75"></div>
              <div className="relative bg-purple-50 p-6 rounded-full">
                <Mail className="w-12 h-12 text-[--asfi-blue]" />
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2">Check Your Email</h2>
          <p className="text-gray-600 mb-6">
            We've sent a verification link to:<br />
            <span className="font-semibold text-[--asfi-blue] break-all">{email}</span>
          </p>

          <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-8 text-left">
            <h4 className="flex items-center text-blue-800 font-semibold text-sm mb-2">
              <CheckCircle className="w-4 h-4 mr-2" />
              What to do next:
            </h4>
            <ul className="text-sm text-blue-700 space-y-2 ml-6 list-disc">
              <li>Click the link in the email to activate your account.</li>
              <li>Check your <strong>Spam</strong> or <strong>Junk</strong> folder if you don't see it.</li>
              <li>Wait at least 5 minutes before requesting a new link.</li>
            </ul>
          </div>

          <div className="space-y-4">
            <Link 
              to="/portal/login" 
              className="w-full flex items-center justify-center px-6 py-3 bg-[--asfi-blue] text-white rounded-md font-medium hover:bg-[--asfi-purple] transition-colors"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Return to Login
            </Link>
          </div>
        </div>

        {/* Support Footer */}
        <div className="bg-gray-50 p-6 border-t border-gray-100 text-center">
          <div className="flex items-center justify-center text-gray-700 mb-2">
            <AlertCircle className="w-4 h-4 mr-2 text-amber-500" />
            <span className="text-sm font-medium">Didn't receive the email?</span>
          </div>
          <p className="text-xs text-gray-500 mb-4">
            If you've checked your spam and waited 10 minutes, please reach out to us.
          </p>
          
          <div className="inline-flex items-center justify-center p-3 bg-white border border-gray-200 rounded-full shadow-sm">
            <MessageCircle className="w-5 h-5 text-[--asfi-blue] mr-2" />
            <span className="text-sm text-gray-700">
              Use the <strong className="text-[--asfi-blue]">Chat Head</strong> at on the right
            </span>
          </div>
        </div>
      </div>

      {/* Footer Branding */}
      <div className="mt-8 text-center">
        <p className="text-gray-400 text-sm">
          &copy; {new Date().getFullYear()} ASFIRJ. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default VerifyNotice;